var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlmaRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "387.000000pt",
    height: "369.000000pt",
    viewBox: "0 0 387.000000 369.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,369.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-color",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF334B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#E61980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A326F5"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FE0103",
    d: "M2804 3635 c-21 -65 -36 -81 -94 -98 -24 -7 -45 -17 -47 -23 -2 -6 20 -20 49 -30 50 -18 55 -22 86 -89 l34 -69 26 68 c27 68 28 69 82 88 30 10 58 22 63 27 5 5 -14 16 -45 26 -69 23 -81 34 -102 100 -9 30 -21 55 -26 55 -5 0 -17 -25 -26 -55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE0103",
    d: "M3321 3561 c-6 -11 -30 -71 -52 -133 -22 -62 -45 -118 -52 -125 -7 -7 -73 -34 -147 -61 -74 -27 -134 -53 -133 -58 2 -12 9 -15 151 -69 81 -31 127 -54 136 -68 8 -12 33 -75 56 -139 24 -65 48 -118 55 -118 6 0 26 44 45 98 61 182 54 173 188 225 64 25 129 49 145 52 33 9 35 23 5 34 -234 84 -260 95 -274 116 -8 12 -33 74 -55 136 -23 63 -45 118 -49 123 -5 4 -13 -1 -19 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE0103",
    d: "M1501 3399 c-89 -11 -256 -50 -366 -86 -468 -154 -865 -537 -1035 -998 -69 -185 -94 -334 -94 -555 0 -151 4 -192 27 -301 52 -246 142 -453 274 -628 18 -24 33 -53 33 -64 0 -11 -41 -148 -90 -305 -50 -157 -90 -295 -90 -308 0 -38 19 -77 58 -116 33 -35 41 -38 89 -38 39 0 69 8 111 28 31 16 175 75 320 131 l263 103 62 -25 c73 -29 249 -81 327 -96 241 -46 510 -37 755 26 483 125 893 452 1114 890 105 211 162 460 162 711 -1 281 -82 581 -219 809 -61 101 -97 126 -174 121 -62 -5 -96 -27 -124 -80 -24 -46 -16 -75 55 -211 121 -229 171 -419 171 -647 0 -189 -28 -332 -97 -499 -90 -218 -270 -443 -478 -599 -79 -58 -277 -161 -375 -193 -353 -115 -675 -102 -1035 42 -55 23 -113 41 -130 41 -16 0 -131 -39 -254 -86 -123 -47 -226 -84 -229 -82 -2 3 24 94 57 203 34 109 61 208 61 218 -1 33 -35 96 -98 179 -235 309 -315 713 -217 1096 31 122 55 183 117 301 186 357 542 624 960 720 129 30 377 37 513 16 207 -33 381 -99 560 -212 99 -63 115 -70 160 -70 88 1 145 54 145 135 0 22 -7 54 -15 69 -31 60 -286 209 -464 270 -94 32 -293 79 -385 91 -94 12 -319 11 -425 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE0103",
    d: "M3657 2833 c-2 -5 -12 -31 -21 -59 -21 -64 -36 -77 -109 -98 -32 -9 -57 -22 -55 -28 2 -6 32 -21 67 -33 35 -13 67 -27 72 -32 5 -5 16 -35 26 -67 10 -33 24 -61 30 -63 7 -3 18 20 29 56 20 71 28 80 106 106 33 11 60 25 61 30 0 6 -31 21 -69 35 l-69 25 -24 68 c-22 62 -34 78 -44 60z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M1100 2271 c-66 -35 -75 -65 -75 -246 0 -182 8 -206 75 -244 66 -37 142 -22 194 39 l27 33 -3 178 c-3 173 -4 178 -28 205 -50 54 -128 69 -190 35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M2065 2156 c-50 -22 -77 -60 -83 -114 -5 -59 13 -100 60 -134 31 -21 44 -23 194 -27 146 -3 166 -1 208 18 38 16 50 29 67 67 33 74 5 154 -64 187 -46 22 -334 24 -382 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M1205 1505 c-18 -17 -25 -35 -25 -64 0 -34 7 -48 55 -99 196 -212 515 -268 775 -137 120 60 240 176 240 231 0 36 -20 71 -47 83 -51 23 -75 14 -154 -62 -137 -132 -286 -175 -452 -132 -86 22 -128 47 -216 130 -69 64 -86 75 -116 75 -25 0 -44 -8 -60 -25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlmaRed);
export default __webpack_public_path__ + "static/media/alma-red.0c8596256c6c5613f90fac71e715edd6.svg";
export { ForwardRef as ReactComponent };